import React, { useEffect } from 'react';
import AddInvoiceItemContent from './AddInvoiceItemContent';
import { useClientInvoiceItemsState } from '../../../../../../../shared/ClientInvoiceItems';
import EditInvoiceItemContent from './EditInvoiceItemContent';
import InvoiceItemsListContent from './InvoiceItemsListContent';
import { RequiredClientBillingInfoGate } from '../../../../../../../shared/EditClientBillingInfo';

export type ClientInvoiceItemsSideDrawerContentOwnProps = {
    clientRecordId: string;
    onClose: (force: boolean) => void;
    onEditBillingDetails: () => void;
};

export type ClientInvoiceItemsSideDrawerContentProps = ClientInvoiceItemsSideDrawerContentOwnProps;

const ClientInvoiceItemsSideDrawerContent: React.FC<ClientInvoiceItemsSideDrawerContentProps> = ({
    clientRecordId,
    onClose,
    onEditBillingDetails,
}) => {
    useEffect(() => {
        if (!clientRecordId) {
            onClose(true);
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [clientRecordId]);

    const {
        state,
        onAddInvoiceLineItem,
        onEditInvoiceLineItem,
        onCancel,
        onEditComplete,
        onAddComplete,
        onInvoiceSent,
    } = useClientInvoiceItemsState({ onComplete: () => onClose(true) });

    if (!clientRecordId) {
        return null;
    }

    const renderContent = () => {
        if (state.type === 'list') {
            return (
                <InvoiceItemsListContent
                    clientRecordId={clientRecordId}
                    onAddInvoiceLineItem={onAddInvoiceLineItem}
                    onEditInvoiceLineItem={onEditInvoiceLineItem}
                    onInvoiceSent={onInvoiceSent}
                    onEditBillingDetails={onEditBillingDetails}
                />
            );
        } else if (state.type === 'add') {
            return (
                <AddInvoiceItemContent
                    clientRecordId={clientRecordId}
                    onCancel={onCancel}
                    onCreateInvoiceItem={onAddComplete}
                />
            );
        } else {
            return (
                <EditInvoiceItemContent
                    clientRecordId={clientRecordId}
                    invoiceItemId={state.invoiceItemId}
                    onCancel={onCancel}
                    onUpdateInvoiceItem={onEditComplete}
                />
            );
        }
    };

    return (
        <RequiredClientBillingInfoGate clientRecordId={clientRecordId}>{renderContent}</RequiredClientBillingInfoGate>
    );
};

export default React.memo(ClientInvoiceItemsSideDrawerContent);
